module.exports = __webpack_public_path__ + "img/img98.f2e3b368.svg";